module.exports = __webpack_public_path__ + "img/HR.5c69b652.svg";